import {
  getCollectDatas,
  subVisitDatas
} from '@/services/config'
export default {
  namespaced: true,
  state: {
    submitting: false,
    datasReady: false,
    datas: {},
    form: '',
    decorators: {
    }
  },
  mutations: {
    // 设置数据容器的值
    setDatas (state, datas) {
      state.datas = datas
    },
    setDatasReady (state, b) {
      state.datasReady = b
    },
    setSubmitting (state, type) {
      state.submitting = type
    },
    setForm (state, form) {
      state.form = form
    }
  },
  actions: {
    async fetchDatas ({ commit }) {
      commit('setDatasReady', false)
      const chain = await getCollectDatas()
        .onSuccess((raw) => {
          commit('setDatas', raw)
        })
        .onNetComplete(() => {
          commit('setDatasReady', true)
        })
        .config({ tip: false })
      return chain
    },
    async subVisit ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await subVisitDatas()
        .onSuccess(async () => {
          // const res = await dispatch('fetchCollectDatas', type)
          // res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    }

  }
}
